import axiosInstance from "../../Lib/axios";
import moment from 'moment';
import {} from "../../Tools/formatToCurrency";
import {RoyaltyReportWrapper} from "./royaltyReportWrapper";
import {CancelationReportWrapper} from "./cancellationReportWrapper";
import {convertFirstCharToUppercase} from "../../Tools/convertFirstLetterToUppercase";
import { aboutUsData } from "../../Assets/data/aboutUsList";
import { message} from "antd";
import {
  GET_DAILY_LOG_FRANCHISE_SUCCESSFULLY,
  GET_DAILY_LOG_FRANCHISE_FAILED,
  GET_DAILY_LOG_REPORTS_SUCCESSFULLY,
  GET_DAILY_LOG_REPORTS_FAILED,
  GET_CUSTOMER_STATEMENT_CUSTOMER_LIST_SUCCESSFULLY,
  GET_CUSTOMER_STATEMENT_CUSTOMER_LIST_FAILED,
  GET_CUSTOMER_STATEMENT_REPORT_SUCCESSFULLY,
  GET_CUSTOMER_STATEMENT_REPORT_FAILED,
  GET_REPORT_PDF_SUCCESSFULLY,
  GET_REPORT_PDF_FAILED,
  GET_REVENUE_REPORT_SUCCESSFULLY,
  GET_REVENUE_REPORT_FAILED,
  GET_REVENUE_REPORT_BY_ID_SUCCESSFULLY,
  GET_REVENUE_REPORT_BY_ID_FAILED,
  GET_REVENUE_REPORT_FRANCHISE_SUCCESSFULLY,
  GET_REVENUE_REPORT_FRANCHISE_FAILED,
  GET_REPORT_ZIPCODE_LIST_SUCCESSFULLY,
  GET_REPORT_ZIPCODE_LIST_FAILED,
  GET_REPORT_TYPE_LIST_SUCCESSFULLY,
  GET_REPORT_TYPE_LIST_FAILED,
  GET_CUSTOMER_COMPLAINTS_FRANCHISE_SUCCESSFULLY,
  GET_CUSTOMER_COMPLAINTS_FRANCHISE_FAILED,
  GET_CUSTOMER_COMPLAINTS_REPORT_SUCCESSFULLY,
  GET_CUSTOMER_COMPLAINTS_REPORT_FAILED,
  GET_CUSTOMER_COMPLAINTS_REPORT_BY_ID_SUCCESSFULLY,
  GET_CUSTOMER_COMPLAINTS_REPORT_BY_ID_FAILED,
  GET_COMMERCIAL_SALES_FRANCHISE_SUCCESSFULLY,
  GET_COMMERCIAL_SALES_FRANCHISE_FAILED,
  GET_COMMERCIAL_SALES_REPORTS_SUCCESSFULLY,
  GET_COMMERCIAL_SALES_REPORTS_FAILED,
  GET_COMMERCIAL_SALES_REPORTS_BY_ID_SUCCESSFULLY,
  GET_COMMERCIAL_SALES_REPORTS_BY_ID_FAILED,
  GET_CUSTOMER_PRICE_INCREASE_REPORT_SUCCESSFULLY,
  GET_CUSTOMER_PRICE_INCREASE_REPORT_FAILED,
  POST_CUSTOMER_PRICE_INCREASE_REPORT_SUCCESSFULLY,
  POST_CUSTOMER_PRICE_INCREASE_REPORT_FAILED,
  GET_CUSTOMER_PRICE_INCREASE_REPORT_USER_ROLES_SUCCESSFULLY,
  GET_CUSTOMER_PRICE_INCREASE_REPORT_USER_ROLES_FAILED,
  GET_CUSTOMER_PRICE_INCREASE_REPORT_FRANCHISES_SUCCESSFULLY,
  GET_CUSTOMER_PRICE_INCREASE_REPORT_FRANCHISES_FAILED,
  GET_CUSTOMER_PRICE_INCREASE_REPORT_BY_ID_SUCCESSFULLY,
  GET_CUSTOMER_PRICE_INCREASE_REPORT_BY_ID_FAILED,
  GET_INVOICE_RECONCILIATION_REPORT_SUCCESSFULLY,
  GET_INVOICE_RECONCILIATION_REPORT_FAILED,
  GET_CANCELLATION_REPORT_SUCCESSFULLY,
  GET_CANCELLATION_REPORT_FAILED,
  GET_CANCELLATION_SUMMARY_REPORT_SUCCESSFULLY,
  GET_CANCELLATION_SUMMARY_REPORT_FAILED,
  GET_ROYALTY_REPORT_SUCCESSFULLY,
  GET_ROYALTY_REPORT_FAILED,
  GET_ROYALTY_REPORT_CSV_FAILED,
  GET_ROYALTY_BREAKDOWN_SUCCESSFULLY,
  GET_ROYALTY_BREAKDOWN_FAILED,
  GET_RESIDENTIAL_LEAD_REPORT_SUCCESSFULLY,
  GET_RESIDENTIAL_LEAD_REPORT_FAILED,
  GET_RESIDENTIAL_SIGNUP_REPORT_SUCCESSFULLY,
  GET_RESIDENTIAL_SIGNUP_REPORT_FAILED,
  GET_RESIDENTIAL_LEAD_REPORT_CSV_FAILED,
  GET_RESIDENTIAL_SIGNUP_REPORT_CSV_FAILED,
  GET_COMMERCIAL_PROPOSAL_REPORT_CSV_FAILED,
  GET_COMMERCIAL_SIGNUP_REPORT_CSV_FAILED,
  GET_CHANNELS_SUCCESSFULLY,
  GET_CHANNELS_FAILED,
  GET_COUPON_CODE_REPORT_SUCCESSFULLY,
  GET_COUPON_CODE_REPORT_FAILED,
  LOADED_EXPORT_REPORT
} from "../types";
import { getCSVColumns } from "./CSVColumns";

// mapping frequency for hardcoded
const FREQUENCY_MAPPING = {
  weekly: 'Weekly',
  bi_monthly: 'Every other week',
  once: 'Just Once',
  twice_weekly: 'Twice Weekly',
  monthly: 'Monthly'
}

// Mapping property types
const PROPERTY_TYPE_MAPPING = {
  townhomes:"Town Homes",
  detached:"Detached homes",
  condo:"Condominiums",
  apartment:"Apartments",
}

const CANCELLATION_REASON = {
	death_of_dog:'Loss of Pet',
	service:'Service Quality',
	moving:'Moving',
	competition:'Pricing',
	other:'Other',
}

// daily log reports
export const getDailyLogFranchise = () => {
  return (dispatch) => {
    return axiosInstance
      .get(`customer-daily-report/franchises/`)
      .then((response) => {
        dispatch({
          type: GET_DAILY_LOG_FRANCHISE_SUCCESSFULLY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
            error?.response?.status === 401 ||
            error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_DAILY_LOG_FRANCHISE_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

export const getDailyLogReports = (params) => {
  let search = ''
  let created_at__date = ''
  let franchise_id = ''
  let ordering = ''
  if(params){
    search = params.search ? params.search : ''
    franchise_id = params.franchise_id? params.franchise_id : ''
    created_at__date = params.created_at__date ? params.created_at__date : ''
    ordering = params.ordering ? params.ordering : ''
  }
  return (dispatch) => {
    return axiosInstance
      .get(`customer-daily-report/?search=${search}&created_at__date=${created_at__date}&franchise_id=${franchise_id}&ordering=${ordering}`)
      .then((response) => {
        dispatch({
          type: GET_DAILY_LOG_REPORTS_SUCCESSFULLY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
                error?.response?.status === 401 ||
                error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_DAILY_LOG_REPORTS_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
}

// customer_statement
export const getCustomerList = () => {
  return (dispatch) => {
    return axiosInstance
      .get(`customer-report/customer_list/`)
      .then((response) => {
        dispatch({
          type: GET_CUSTOMER_STATEMENT_CUSTOMER_LIST_SUCCESSFULLY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
            error?.response?.status === 401 ||
            error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_CUSTOMER_STATEMENT_CUSTOMER_LIST_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};
  
export const getCSReport = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`customer-report/?user__uuid=${params.user__uuid}&invoice_date__range=${params.invoice_date__range}`)
      .then((response) => {
        dispatch({
          type: GET_CUSTOMER_STATEMENT_REPORT_SUCCESSFULLY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
            error?.response?.status === 401 ||
            error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_CUSTOMER_STATEMENT_REPORT_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
}

//pdf api
export const getPdfReport = (params) => {
  let url=''
  if(params.searchquery){
    url=`download-customer-report?report_type=${params.report_type}&is_export=${params.is_export}&${params.searchquery}`
  } else {
    url=`download-customer-report?report_type=${params.report_type}&is_export=${params.is_export}`
  }
  return (dispatch) => {
    return axiosInstance
      .get(url, params)
      .then((response) => {
        dispatch({
          type: GET_REPORT_PDF_SUCCESSFULLY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
            error?.response?.status === 401 ||
            error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_REPORT_PDF_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
}

// in territory reports
export const getReportZipCodeList = () => {
  return (dispatch) => {
    return axiosInstance
      .get(`customer-territory-revenue-report/get_zip_codes/`)
      .then((response) => {
        dispatch({
          type: GET_REPORT_ZIPCODE_LIST_SUCCESSFULLY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
                error?.response?.status === 401 ||
                error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_REPORT_ZIPCODE_LIST_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
}

export const getReportTypeList = () => {
  return (dispatch) => {
    return axiosInstance
      .get(`customer-territory-revenue-report/get_field_type/`)
      .then((response) => {
        dispatch({
          type: GET_REPORT_TYPE_LIST_SUCCESSFULLY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
                error?.response?.status === 401 ||
                error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_REPORT_TYPE_LIST_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
}

export const getInvoiceReconciliationReport = (params) => {
  let url = `invoice/get_invoice_reconcilation_report?field_office__uuid=${params.field_office_uuid}&start_date=${params.start_date}&end_date=${params.end_date}`
  return (dispatch) => {
    return axiosInstance
      .get(url)
      .then((response) => {
        dispatch({
          type: GET_INVOICE_RECONCILIATION_REPORT_SUCCESSFULLY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
                error?.response?.status === 401 ||
                error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_INVOICE_RECONCILIATION_REPORT_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
}

export const getRevenueReport = (params) => {
  let url = 'customer-territory-revenue-report/'
  if(params){
    let keys=Object.keys(params)
    for(let i = 0; i< keys.length; i++){
      if(i===0 && i === keys.length - 1){
        url+= `?${keys[i]}=${params[keys[i]]}`
      } else if(i===0 && i !== keys.length - 1){
        url+= `?${keys[i]}=${params[keys[i]]}&`
      } else if(i === keys.length - 1){
        url += `${keys[i]}=${params[keys[i]]}`
      } else {
        url += `${keys[i]}=${params[keys[i]]}&`
      }
    }
  }
  return (dispatch) => {
    return axiosInstance
      .get(url)
      .then((response) => {
        dispatch({
          type: GET_REVENUE_REPORT_SUCCESSFULLY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
                  error?.response?.status === 401 ||
                  error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_REVENUE_REPORT_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
}

export const getRevenueReportById = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`customer-territory-revenue-report/${params.id}/?type=${params.type}`)
      .then((response) => {
        dispatch({
          type: GET_REVENUE_REPORT_BY_ID_SUCCESSFULLY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
                error?.response?.status === 401 ||
                error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_REVENUE_REPORT_BY_ID_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
}

export const getRevenueReportFranchise = () => {
  return (dispatch) => {
    return axiosInstance
      .get(`/customer-territory-revenue-report/franchises/`)
      .then((response) => {
        dispatch({
          type: GET_REVENUE_REPORT_FRANCHISE_SUCCESSFULLY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
            error?.response?.status === 401 ||
            error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_REVENUE_REPORT_FRANCHISE_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// customer complaints report
export const getCustomerComplaintsFranchise = () => {
  return (dispatch) => {
    return axiosInstance
      .get(`/customer-complaints-report/franchises/`)
      .then((response) => {
        dispatch({
          type: GET_CUSTOMER_COMPLAINTS_FRANCHISE_SUCCESSFULLY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
            error?.response?.status === 401 ||
            error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_CUSTOMER_COMPLAINTS_FRANCHISE_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

export const getCustomerComplaintsReport = (params) => {
  let url = `customer-complaints-report/`
  if(params){
    let keys=Object.keys(params)
    for(let i = 0; i< keys.length; i++){
      if(i===0 && i === keys.length - 1){
        url+= `?${keys[i]}=${params[keys[i]]}`
      } else if(i===0 && i !== keys.length - 1){
        url+= `?${keys[i]}=${params[keys[i]]}&`
      } else if(i === keys.length - 1){
        url += `${keys[i]}=${params[keys[i]]}`
      } else {
        url += `${keys[i]}=${params[keys[i]]}&`
      }
    }
  }
  return (dispatch) => {
    return axiosInstance
      .get(url)
      .then((response) => {
        dispatch({
          type: GET_CUSTOMER_COMPLAINTS_REPORT_SUCCESSFULLY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
                error?.response?.status === 401 ||
                error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_CUSTOMER_COMPLAINTS_REPORT_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
}
  
export const getCustomerComplaintsReportById = (params) => {
  let url = `customer-complaints-report/${params.id}/get_tickets/`
  if(params){
    let keys=Object.keys(params)
    for(let i = 0; i< keys.length; i++){
      if(i===0 && i === keys.length - 1){
        url+= `?${keys[i]}=${params[keys[i]]}`
      } else if(i===0 && i !== keys.length - 1){
        url+= `?${keys[i]}=${params[keys[i]]}&`
      } else if(i === keys.length - 1){
        url += `${keys[i]}=${params[keys[i]]}`
      } else {
        url += `${keys[i]}=${params[keys[i]]}&`
      }
    }
  }
  // if(params.date_range){
  //   url = `customer-complaints-report/${params.id}/get_tickets/?date_range=${params.date_range}`
  // }
  return (dispatch) => {
    return axiosInstance
      .get(url)
      .then((response) => {
        dispatch({
          type: GET_CUSTOMER_COMPLAINTS_REPORT_BY_ID_SUCCESSFULLY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
                error?.response?.status === 401 ||
                error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_CUSTOMER_COMPLAINTS_REPORT_BY_ID_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
}

// commercial sales report
export const getCommercialSalesFranchise = () => {
  return (dispatch) => {
    return axiosInstance
      .get(`/customer-commercial-sales-report/get_franchises/`)
      .then((response) => {
        dispatch({
          type: GET_COMMERCIAL_SALES_FRANCHISE_SUCCESSFULLY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
            error?.response?.status === 401 ||
            error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_COMMERCIAL_SALES_FRANCHISE_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

export const getCommercialSalesReports = (params) => {
  let url = 'customer-commercial-sales-report/'
  if(params){
    let keys=Object.keys(params)
    for(let i = 0; i< keys.length; i++){
      if(i===0 && i === keys.length - 1){
        url+= `?${keys[i]}=${params[keys[i]]}`
      } else if(i===0 && i !== keys.length - 1){
        url+= `?${keys[i]}=${params[keys[i]]}&`
      } else if(i === keys.length - 1){
        url += `${keys[i]}=${params[keys[i]]}`
      } else {
        url += `${keys[i]}=${params[keys[i]]}&`
      }
    }
  }
  return (dispatch) => {
    return axiosInstance
      .get(url)
      .then((response) => {
        dispatch({
          type: GET_COMMERCIAL_SALES_REPORTS_SUCCESSFULLY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
          error?.response?.status === 401 ||
          error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_COMMERCIAL_SALES_REPORTS_FAILED,
            data: error?.response?.data,
          });
        }
      });

  };
}

export const getCommercialSalesReportsDetails = (params) => {
  let url = `customer-commercial-sales-report/${params.id}/`
  if(params){
    let keys=Object.keys(params)
    const index = keys.indexOf('id');
    if (index > -1) {
      keys.splice(index, 1);
    }
    for(let i = 0; i< keys.length; i++){
      if(i===0 && i === keys.length - 1){
        url+= `?${keys[i]}=${params[keys[i]]}`
      } else if(i===0 && i !== keys.length - 1){
        url+= `?${keys[i]}=${params[keys[i]]}&`
      } else if(i === keys.length - 1){
        url += `${keys[i]}=${params[keys[i]]}`
      } else {
        url += `${keys[i]}=${params[keys[i]]}&`
      }

    }
  }
  return (dispatch) => {
    return axiosInstance
      .get(url)
      .then((response) => {
        dispatch({
          type: GET_COMMERCIAL_SALES_REPORTS_BY_ID_SUCCESSFULLY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
          error?.response?.status === 401 ||
          error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_COMMERCIAL_SALES_REPORTS_BY_ID_FAILED,
            data: error?.response?.data,
          });
        }
      });

  };
}

// API FOR customer-price-increase-report
export const getCustomerPriceIncreaseReport = (params) => {
  let url = 'customer-price-increase-report/'
  if(params){
    let keys=Object.keys(params)
    for(let i = 0; i< keys.length; i++){
      if(i===0 && i === keys.length - 1){
        url+= `?${keys[i]}=${params[keys[i]]}`
      } else if(i===0 && i !== keys.length - 1){
        url+= `?${keys[i]}=${params[keys[i]]}&`
      } else if(i === keys.length - 1){
        url += `${keys[i]}=${params[keys[i]]}`
      } else {
        url += `${keys[i]}=${params[keys[i]]}&`
      }
    }
  }
 
  return (dispatch) => {
    return axiosInstance
      .get(url)
      .then((response) => {
        dispatch({
          type: GET_CUSTOMER_PRICE_INCREASE_REPORT_SUCCESSFULLY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
                error?.response?.status === 401 ||
                error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_CUSTOMER_PRICE_INCREASE_REPORT_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
}

export const postCustomerPriceIncreaseReport = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`customer-price-increase-report/`, params)
      .then((response) => {
        dispatch({
          type: POST_CUSTOMER_PRICE_INCREASE_REPORT_SUCCESSFULLY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
                error?.response?.status === 401 ||
                error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: POST_CUSTOMER_PRICE_INCREASE_REPORT_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
}

export const getCustomerPriceIncreaseReportUserRoles = () => {
  return (dispatch) => {
    return axiosInstance
      .get(`customer-price-increase-report/get_customer_user_roles/`)
      .then((response) => {
        dispatch({
          type: GET_CUSTOMER_PRICE_INCREASE_REPORT_USER_ROLES_SUCCESSFULLY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
                error?.response?.status === 401 ||
                error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_CUSTOMER_PRICE_INCREASE_REPORT_USER_ROLES_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
}

export const getCustomerPriceIncreaseReportFranchises = () => {
  return (dispatch) => {
    return axiosInstance
      .get(`customer-price-increase-report/get_franchises/`)
      .then((response) => {
        dispatch({
          type: GET_CUSTOMER_PRICE_INCREASE_REPORT_FRANCHISES_SUCCESSFULLY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
                error?.response?.status === 401 ||
                error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_CUSTOMER_PRICE_INCREASE_REPORT_FRANCHISES_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
}

export const getCustomerPriceIncreaseReportById = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`customer-price-increase-report/${params.id}/`)
      .then((response) => {
        dispatch({
          type: GET_CUSTOMER_PRICE_INCREASE_REPORT_BY_ID_SUCCESSFULLY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
                error?.response?.status === 401 ||
                error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_CUSTOMER_PRICE_INCREASE_REPORT_BY_ID_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
}

/**
 * AUTHOR: Ritesh Solanki
 * @param {*} params 
 * @returns 
 * <DP-4170>View the Cancelation Report, Initiate</DP-4170>
 */
export const getCancellationReport = (params) => {
  let url = `crm/customer-cancelation-report/`
  if(params){
    let keys=Object.keys(params)
    for(let i = 0; i< keys.length; i++){
      if(i===0 && i === keys.length - 1){
        url+= `?${keys[i]}=${params[keys[i]]}`
      } else if(i===0 && i !== keys.length - 1){
        url+= `?${keys[i]}=${params[keys[i]]}&`
      } else if(i === keys.length - 1){
        url += `${keys[i]}=${params[keys[i]]}`
      } else {
        url += `${keys[i]}=${params[keys[i]]}&`
      }
    }
  }

  return (dispatch) => {
    return axiosInstance
      .get(url)
      .then((response) => {
        dispatch({
          type: GET_CANCELLATION_REPORT_SUCCESSFULLY,
          data: CancelationReportWrapper(response?.data),
        });
      })
      .catch((error) => {
        if (
            error?.response?.status === 401 ||
            error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_CANCELLATION_REPORT_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
}

export const getCancellationSummaryReport = (params) => {
  let url = `crm/customer-cancelation-report/cancelation_customer_summary/`
  if(params){
    let keys=Object.keys(params)
    for(let i = 0; i< keys.length; i++){
      if(i===0 && i === keys.length - 1){
        url+= `?${keys[i]}=${params[keys[i]]}`
      } else if(i===0 && i !== keys.length - 1){
        url+= `?${keys[i]}=${params[keys[i]]}&`
      } else if(i === keys.length - 1){
        url += `${keys[i]}=${params[keys[i]]}`
      } else {
        url += `${keys[i]}=${params[keys[i]]}&`
      }
    }
  }
  return (dispatch) => {
    return axiosInstance
      .get(url)
      .then((response) => {
        dispatch({
          type: GET_CANCELLATION_SUMMARY_REPORT_SUCCESSFULLY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
                error?.response?.status === 401 ||
                error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_CANCELLATION_SUMMARY_REPORT_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
}

// Royalty Report
export const getRoyaltyReport = (data) => {
  const params = new URLSearchParams();
  params.append("end_date", data.end_date);
  params.append("start_date", data.start_date);

  if (data?.field_office_uuids?.length > 1) {
    const franchises = data?.field_office_uuids?.join(',');
    params.append("field_office_uuids", franchises);
  }

  if (data?.field_office_uuids?.length === 1)
  {
    params.append("field_office_uuids",  data?.field_office_uuids);
  }

  const request = { params };

  return (dispatch) => {
    return axiosInstance
      .get(`royalty-report/get_report/`, request)
      .then((response) => {
        dispatch({
          type: GET_ROYALTY_REPORT_SUCCESSFULLY,
          data: RoyaltyReportWrapper(response?.data),
        });
      })
      .catch((error) => {
        if (
                error?.response?.status === 401 ||
                error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_ROYALTY_REPORT_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
}

// Royalty Report CSV
export const getRoyaltyReportCSV = ( filters ) => {
  const params = new URLSearchParams();
  params.append("end_date", filters.end_date);
  params.append("start_date", filters.start_date);

  if (filters?.field_office_uuids?.length > 0) {
    const franchises = filters.field_office_uuids.join(',');
    params.append("field_office_uuids", franchises);
  }

  const request = {params, headers: {'Accept': 'text/csv'}};

  return (dispatch) => {
    return axiosInstance
      .get('royalty-report/get_report/', request)
      .then((response) => {
        let data = response.data;
        var blob = new Blob([data], { type: "text/csv"});
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "Royalty Report.csv";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        dispatch({
          type: LOADED_EXPORT_REPORT,
        });
      })
      .catch((error) => {
        console.log("Export in catch error",error);
        dispatch({
          type: LOADED_EXPORT_REPORT,
        });
        message.error('Error while exporting data.');

        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_ROYALTY_REPORT_CSV_FAILED,
              data: error.response.data,
            });
          }
        }
      })
  }
}

export const getRoyaltyReportForViewBreakDown = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`royalty-report/get_break_by_territory/`, {params})
      .then((response) => {
        dispatch({
          type: GET_ROYALTY_BREAKDOWN_SUCCESSFULLY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
                error?.response?.status === 401 ||
                error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_ROYALTY_BREAKDOWN_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
}

// Residential
// Lead Report
export const getLeadReport = (data) => {
  let field_office__uuid, 
    stage, 
    outreach,
    status,
    hear_about_us,
    created_at__lte,
    created_at__gte,
    channel_attribution__uuid,
    lead_status_logs__created_at__range
  ;
  
  if (data?.field_office_uuids?.length > 1) {
    const franchises = data?.field_office_uuids?.join(',');
    field_office__uuid = franchises;
  }

  if (data?.field_office_uuids?.length === 1)
  {
    field_office__uuid = data?.field_office_uuids?.join(',');
  }

  if(!data?.leadStage?.includes('all')) 
  {
    stage = data?.leadStage?.join(',');
  }

  if(!data?.outreach?.includes('all'))
  {
    outreach = data?.outreach?.join(',');
  }

  if(!data?.leadStatus?.includes('all'))
  {
    status = data?.leadStatus?.join(',');
  }

  if(!data?.channelAttribution?.includes('all'))
  {
    channel_attribution__uuid = data?.channelAttribution?.join(',');
  }
  
  if(!data?.hearAboutUs?.includes('all'))
  {
    hear_about_us = data?.hearAboutUs?.join(',');
  }

  if(data?.lastContactStartDate && data?.lastContactEndDate)
  {
    lead_status_logs__created_at__range= `${moment(data.lastContactStartDate).format('YYYY-MM-DDT00:00:00')},${moment(data.lastContactEndDate).format('YYYY-MM-DDT23:59:59')}`
  }

  if(data?.leadCreationEndDate && data?.leadCreationStartDate)
  {
    created_at__lte = moment(data.leadCreationEndDate).format('YYYY-MM-DDT23:59:59');
    created_at__gte = moment(data.leadCreationStartDate).format('YYYY-MM-DDT00:00:00');
  }

  const params = {
    stage,
    status,
    outreach,
    hear_about_us,
    created_at__lte,
    created_at__gte,
    limit: data.limit,
    field_office__uuid,
    offset: data.offset,
    channel_attribution__uuid,
    ordering: data.ordering,
    lead_status_logs__created_at__range,
  }

  return (dispatch) => {
    return axiosInstance
      .get(`crm/lead-user/`, {params})
      .then((response) => {
        dispatch({
          type: GET_RESIDENTIAL_LEAD_REPORT_SUCCESSFULLY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
                error?.response?.status === 401 ||
                error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_RESIDENTIAL_LEAD_REPORT_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
}

// Get Residential Lead Report CSV
export const getLeadReportCSV = (data) => {
  let params = {};

  if (data?.field_office_uuids?.length > 0) {
    const franchises = data.field_office_uuids.join(',');
    params = { 
      "field_office__uuid": franchises,
      ...params,
    };
  }

  if(data?.leadStage && !data?.leadStage?.includes('all')) 
  {
    params = { 
      "stage": data?.leadStage?.join(','),
      ...params,
    };
  }

  if(data?.outreach && !data?.outreach?.includes('all'))
  {
    params = {
      "outreach": data?.outreach?.join(','),
      ...params,
    };
  }

  if(data?.leadStatus && !data?.leadStatus?.includes('all'))
  {
    params = {
      "status": data?.leadStatus?.join(','),
      ...params,
    };
  }
  
  if(data?.hearAboutUs && !data?.hearAboutUs?.includes('all'))
  {
    params = {
      "hear_about_us": data?.hearAboutUs?.join(','),
      ...params,
    };
  }

  if(data?.channelAttribution && !data?.channelAttribution?.includes('all'))
  {
    params = {
      "channel_attribution__uuid": data?.channelAttribution?.join(','),
      ...params,
    };
  }

  if(data?.lastContactStartDate && data?.lastContactEndDate)
  {
    const lead_status_logs__created_at__range = `${moment(data.lastContactStartDate).format('YYYY-MM-DDT00:00:00')},${moment(data.lastContactEndDate).format('YYYY-MM-DDT23:59:59')}`;
    params = {
      "lead_status_logs__created_at__range": lead_status_logs__created_at__range,
      ...params,
    };
  }

  if(data?.leadCreationEndDate && data?.leadCreationStartDate)
  {
    params = {
      "created_at__lte": moment(data.leadCreationEndDate).format('YYYY-MM-DDT23:59:59'),
      ...params,
    };
    params = {
      "created_at__gte": moment(data.leadCreationStartDate).format('YYYY-MM-DDT00:00:00'),
      ...params,
    };
  }

  if(data.ordering && data.ordering !== '')
  {
    params = {
      "ordering": data.ordering,
      ...params,
    };
  }

  params = {
    "offset": 0,
    "limit": 100000,
    ...params,
  };

  return (dispatch) => {
    return axiosInstance
      .get(`crm/lead-user/`, {params}, {timeout: 50000})
      .then((response) => {
        let headers = getCSVColumns('residential-lead');
        let data = response.data.results;
        let rows = [headers.join(',')];

        data.forEach(item => {
          let row =
            `${item?.first_name ? item?.first_name + " " + item?.last_name : 'NA'},` +
            `${item?.field_office?.name ? item?.field_office?.name : 'NA'},` +
            `${item?.is_active ? 'Active' : 'Inactive'},` +
            `${item?.created_at ? moment(item?.created_at).format("L") : 'NA'},` +
            `${item?.zip_code ? item?.zip_code : 'NA'},` +
            `${item?.lead_stage ? convertFirstCharToUppercase(item?.lead_stage) : 'NA'},` +
            `${item?.lead_status_logs?.length > 0 ? moment(item.lead_status_logs[0].created_at).format("L") : 'NA'},` +
            `${item?.outreach ? convertFirstCharToUppercase( item?.outreach.replaceAll("_", ' ')) : 'NA'},` +
            `${item?.channel_attribution && item?.channel_attribution?.name !== 'Unknown' ? item?.channel_attribution?.name : 'NA'},` +
            `${item?.hear_about_us?.length > 0 && aboutUsData.filter(element => item?.hear_about_us?.includes(element.value))?.length ? `"${aboutUsData.filter(element => item?.hear_about_us?.includes(element.value)).map(item2 => {return item2.name}).join(', ')}"` : 'NA'},` +
            `${item?.email?.includes('@doody.com') ? 'NA' : item?.email}`
          ;

          rows.push(row);
        });

        // To use
        let blob = new Blob([rows.join('\n')], { type: "application/CSV" });
        
        blob.text().then((csvContent) => {
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(new Blob([csvContent], { type: "application/CSV" }));
          
          let fileName = "Residential Lead Report.csv";
          link.download = fileName;
          document.body.appendChild(link);
  
          link.click();
          document.body.removeChild(link);
        })
        dispatch({
          type: LOADED_EXPORT_REPORT,
        });
      })
      .catch((error) => {
        console.log("Export in catch error",error);
        dispatch({
          type: LOADED_EXPORT_REPORT,
        });
        message.error('Error while exporting data.');

        if (
                error?.response?.status === 401 ||
                error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_RESIDENTIAL_LEAD_REPORT_CSV_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
}

// Signup Residential Report
export const getSignupReport = (data) => {
  let 
    outreach,
    frequency,
    hear_about_us,
    last_serviced,
    created_at__lte,
    created_at__gte,
    channel_attribution__uuid,
    serviceorder__service_address__zip_code,
    serviceorder__field_office__uuid;
  
  if (data?.field_office_uuids?.length > 1) {
    const franchises = data?.field_office_uuids?.join(',');
    serviceorder__field_office__uuid = franchises;
  }

  if (data?.field_office_uuids?.length === 1)
  {
    serviceorder__field_office__uuid = data?.field_office_uuids?.join(',');
  }

  if(!data?.outreach?.includes('all'))
  {
    outreach = data?.outreach?.join(',');
  }
  
  if(!data?.hearAboutUs?.includes('all'))
  {
    hear_about_us = data?.hearAboutUs?.join(',');
  }

  if(!data?.frequency?.includes('all'))
  {
    frequency = data?.frequency?.join(',');
  }

  if(data?.lastServiceStartDate && data?.lastServiceEndDate)
  {
    last_serviced= `${moment(data.lastServiceStartDate).format('YYYY-MM-DD')},${moment(data?.lastServiceEndDate).format('YYYY-MM-DD')}`;
    // last_serviced= `${moment(data.lastServiceStartDate).format('YYYY-MM-DDT00:00:00')},${moment(data?.lastServiceEndDate).format('YYYY-MM-DDT23:59:59')}`
  }

  if(!data?.channelAttribution?.includes('all'))
  {
    channel_attribution__uuid = data?.channelAttribution?.join(',');
  }

  if(data?.joinedEndDate && data?.joinedStartDate)
  {
    created_at__lte = moment(data.joinedEndDate).format('YYYY-MM-DDT23:59:59');
    created_at__gte = moment(data.joinedStartDate).format('YYYY-MM-DDT00:00:00');
  }

  if(data?.zipcodes && data?.zipcodes !== "")
  {
    serviceorder__service_address__zip_code = data?.zipcodes;
  }

  const params = {
    outreach,
    frequency,
    last_serviced,
    hear_about_us,
    created_at__lte,
    created_at__gte,
    limit: data.limit,
    offset: data.offset,
    channel_attribution__uuid,
    ordering: data.ordering,
    serviceorder__field_office__uuid,
    serviceorder__service_address__zip_code
  }

  return (dispatch) => {
    return axiosInstance
      .get(`crm/customer-user`, {params})
      .then((response) => {
        dispatch({
          type: GET_RESIDENTIAL_SIGNUP_REPORT_SUCCESSFULLY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
                error?.response?.status === 401 ||
                error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_RESIDENTIAL_SIGNUP_REPORT_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
}

// Get Sign up Report CSV
export const getSignupReportCSV = (data) => {
  let params ={};

  if (data?.field_office_uuids?.length > 0) {
    params = {
      "serviceorder__field_office__uuid": data.field_office_uuids.join(','),
      ...params
    };
  }

  if(data?.frequency && !data?.frequency?.includes('all'))
  {
    params = {
      "frequency": data?.frequency?.join(','),
      ...params
    };
  }
  
  if(data?.hearAboutUs && !data?.hearAboutUs?.includes('all'))
  {
    params = {
      "hear_about_us": data?.hearAboutUs?.join(','),
      ...params
    };
  }

  if(data?.channelAttribution && !data?.channelAttribution?.includes('all'))
  {
    params = {
      "channel_attribution__uuid": data?.channelAttribution?.join(','),
      ...params
    };
  }

  if(data?.lastServiceStartDate && data?.lastServiceEndDate)
  {
    const last_serviced= `${moment(data.lastServiceStartDate).format('YYYY-MM-DD')},${moment(data?.lastServiceEndDate).format('YYYY-MM-DD')}`;
    params = {
      "last_serviced": last_serviced,
      ...params
    };
  }

  if(data?.joinedEndDate && data?.joinedStartDate)
  {
    params = {
      "created_at__lte": moment(data.joinedEndDate).format('YYYY-MM-DDT23:59:59'),
      ...params
    };
    params = {
      "created_at__gte": moment(data.joinedStartDate).format('YYYY-MM-DDT00:00:00'),
      ...params
    };
  }

  if(data?.zipcodes && data?.zipcodes !== "")
  {
    params = {
      "serviceorder__service_address__zip_code": data?.zipcodes,
      ...params
    };
  }

  params = {
    "offset": 0,
    "limit": 100000,
    ...params
  };

  return (dispatch) => {
    return axiosInstance
      .get(`crm/customer-user`, {params}, {timeout: 50000})
      .then((response) => {
        let headers = getCSVColumns('residential-signup');
        let data = response.data.results;
        let rows = [headers.join(',')];

        data.forEach(item => {
          let row =
            `${item?.first_name ? item?.first_name + " " + item?.last_name : 'NA'},` +
            `${item?.field_office?.name ? item?.field_office?.name : 'NA'},` +
            `${item?.is_active ? 'Active' : 'Inactive'},` +
            `${item?.created_at ? moment(item?.created_at).format("L") : 'NA'},` +
            `${item?.frequency?.length > 0 ? `"${item?.frequency.map(item => FREQUENCY_MAPPING[item]).join(', ')}"` : 'NA'},` +
            `${item?.last_service?.length > 0 ? item?.last_service : 'NA'},` +
            `${item?.invoice_address?.address ?item?.invoice_address?.address :'NA'},` +
            `${item?.invoice_address?.city ?item?.invoice_address?.city :'NA'},` +
            `${item?.invoice_address?.state ?item?.invoice_address?.state:'NA'},` +
            `${item?.invoice_address?.zip_code ?item?.invoice_address?.zip_code :'NA'},` +
            `${item?.channel_attribution && item?.channel_attribution?.name !== 'Unknown' ? item?.channel_attribution?.name : 'NA'},` +
            `${item?.hear_about_us?.length > 0 && aboutUsData.filter(element => item?.hear_about_us?.includes(element.value))?.length ? `"${aboutUsData.filter(element => item?.hear_about_us?.includes(element.value)).map(item2 => {return item2.name}).join(', ')}"` : 'NA'},` +
            `${item?.email?.includes('@doody.com') ? 'NA' : item?.email}`
          ;

          rows.push(row);
        });

        // To use
        let blob = new Blob([rows.join('\n')], { type: "application/CSV" });
        
        blob.text().then((csvContent) => {
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(new Blob([csvContent], { type: "application/CSV" }));
          
          let fileName = "Residential Sign up Report.csv";
          link.download = fileName;
          document.body.appendChild(link);
  
          link.click();
          document.body.removeChild(link);
        })
        dispatch({
          type: LOADED_EXPORT_REPORT,
        });
      })
      .catch((error) => {
        console.log("Export in catch error",error);
        dispatch({
          type: LOADED_EXPORT_REPORT,
        });
        message.error('Error while exporting data.');

        if (
                error?.response?.status === 401 ||
                error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_RESIDENTIAL_SIGNUP_REPORT_CSV_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
}

// Commercials
// Signup Commercial Report
export const getSignupCommercialReport = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`crm/commerical-customer`, {params})
      .then((response) => {
        dispatch({
          type: GET_RESIDENTIAL_SIGNUP_REPORT_SUCCESSFULLY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
                error?.response?.status === 401 ||
                error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_RESIDENTIAL_SIGNUP_REPORT_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
}

// Proposal Report CSV
export const getProposalReportCSV = (data) => {
  const params = {
    ...data,
    "offset": 0,
    "limit": 100000
  }

  return (dispatch) => {
    return axiosInstance
      .get(`crm/commerical-crm/`, {params}, {timeout: 50000})
      .then((response) => {
        let headers = getCSVColumns('commercial-proposal');
        let data = response.data.results;
        let rows = [headers.join(',')];
        data.forEach(item => {
          let row =
            `${item?.community_name ? convertFirstCharToUppercase(item?.community_name) : 'NA'},` +
            `${item?.first_name ? convertFirstCharToUppercase(item?.first_name) + ' ' + convertFirstCharToUppercase(item?.last_name) : 'NA'},` +
            `${item?.management_company ? convertFirstCharToUppercase(item?.management_company) : 'NA'},` +
            `${item?.properties_in_community && item?.properties_in_community?.length ? `"${item?.properties_in_community?.map(item => {return PROPERTY_TYPE_MAPPING[item]}).join(', ')}"` : 'NA' },` +
            `${item?.field_office?.name ? item?.field_office?.name : 'NA'},` +
            `${item?.created_at ? moment(item?.created_at).format("L") : 'NA'},` +
            `${item?.interested_services && item?.interested_services?.length ? `"${item?.interested_services?.map(item => {return convertFirstCharToUppercase(item.replaceAll("_", " "))}).join(', ')}"` : 'NA'},` +
            `${item?.interested_products && item?.interested_products?.length ? `"${item?.interested_products?.map(item => {return convertFirstCharToUppercase(item.replaceAll("_", " "))}).join(', ')}"` : 'NA'},` +
            `${item?.address ? item?.address?.address : 'NA'},` +
            `${item?.address ? item?.address?.city : 'NA'},` +
            `${item?.address ? item?.address?.state : 'NA'},` +
            `${item?.address?.zip_code ? item?.address?.zip_code :'NA'},` +
            `${item?.outreach ? convertFirstCharToUppercase( item?.outreach.replaceAll("_", ' ')) : 'NA'},` +
            `${item?.channel_attribution && item?.channel_attribution?.name !== 'Unknown' ? item?.channel_attribution?.name : 'NA'},` +
            `${item?.hear_about_us?.length > 0 && aboutUsData.filter(element => item?.hear_about_us?.includes(element.value))?.length ? `"${aboutUsData.filter(element => item?.hear_about_us?.includes(element.value)).map(item2 => {return item2.name}).join(', ')}"` : 'NA'},` +
            `${item?.email_address?.includes('@doody.com') ? 'NA' : item?.email_address}`
          ;

          rows.push(row);
        });

        // To use
        let blob = new Blob([rows.join('\n')], { type: "application/CSV" });
        
        blob.text().then((csvContent) => {
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(new Blob([csvContent], { type: "application/CSV" }));
          
          let fileName = "Commercial Proposal Report.csv";
          link.download = fileName;
          document.body.appendChild(link);
  
          link.click();
          document.body.removeChild(link);
        })
        dispatch({
          type: LOADED_EXPORT_REPORT,
        });
      })
      .catch((error) => {
        console.log("Export in catch error",error);
        dispatch({
          type: LOADED_EXPORT_REPORT,
        });
        message.error('Error while exporting data.');

        if (
                error?.response?.status === 401 ||
                error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_COMMERCIAL_PROPOSAL_REPORT_CSV_FAILED,
            data: error?.response?.data,
          });
        }
    });
  };
}

// Signup Commercial Report
export const getSignupCommercialReportCSV = (data) => {
  const params = {
    ...data,
    "offset": 0,
    "limit": 100000
  }

  const getFirstItemOrDefault = (array) => {
    const hasItems = array !== undefined && array !== null && array.length > 0

    if (!hasItems) {
      return {}
    }

    return array[0];
  }

  return (dispatch) => {
    return axiosInstance
      .get(`crm/commerical-customer`, {params}, {timeout: 50000})
      .then((response) => {
        let headers = getCSVColumns('commercial-signup');
        let data = response.data.results;
        let rows = [headers.join(',')];

        data.forEach(item => {
          let row =
          `${item?.community_name ? convertFirstCharToUppercase(item?.community_name) : 'NA'},` +
          `${item?.first_name ? convertFirstCharToUppercase(item?.first_name) + ' ' + convertFirstCharToUppercase(item?.last_name) : 'NA'},` +
          `${item?.management_company ? convertFirstCharToUppercase(item?.management_company) : 'NA'},` +
          `${item?.property_type && item?.property_type?.length ? `"${item?.property_type?.map(item => {return PROPERTY_TYPE_MAPPING[item]}).join('\, ')}"` : 'NA' },` +
          `${item?.field_office?.name ? item?.field_office?.name : 'NA'},` +
          `${item?.created_at ? moment(item?.created_at).format("L") : 'NA'},` +
          `${item?.service_list && item?.service_list?.length > 0 ? `"${item?.service_list?.map(element => {return convertFirstCharToUppercase(element[0].item.replaceAll("_", " "))}).join(', ')}"` : 'NA'},` +
          `${item?.product_list && item?.product_list?.length > 0 ? `"${item?.product_list?.map(element => {return (convertFirstCharToUppercase(element[0].item.replaceAll("_", " ")))}).join(', ')}"` : 'NA'},` +
          `${item?.frequency_list?.length > 0 ? `"${item?.frequency_list.map(item => {return FREQUENCY_MAPPING[item]}).join(', ')}"` : 'NA'},` +
          `${item?.address ? getFirstItemOrDefault(item?.address)?.address : 'NA'},` +
          `${item?.address ? getFirstItemOrDefault(item?.address)?.city : 'NA'},` +
          `${item?.address ? getFirstItemOrDefault(item?.address)?.state : 'NA'},` +
          `${item?.address ? getFirstItemOrDefault(item?.address)?.zip_code : 'NA'},` +
          `${item?.outreach ? convertFirstCharToUppercase( item?.outreach.replaceAll("_", ' ')) : 'NA'},` +
          `${item?.channel_attribution && item?.channel_attribution?.name !== 'Unknown' ? item?.channel_attribution?.name : 'NA'},` +
          `${item?.hear_about_us?.length > 0 && aboutUsData.filter(element => item?.hear_about_us?.includes(element.value))?.length  ? `"${aboutUsData.filter(element => item?.hear_about_us?.includes(element.value)).map(item2 => {return item2.name}).join('\, ')}"` : 'NA'},` +
          `${item?.email?.includes('@doody.com') ? 'NA' : item?.email}`
          ;

          rows.push(row);
        });

        // To use
        let blob = new Blob([rows.join('\n')], { type: "application/CSV" });
        
        blob.text().then((csvContent) => {
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(new Blob([csvContent], { type: "application/CSV" }));
          
          let fileName = "Commercial Signup Report.csv";
          link.download = fileName;
          document.body.appendChild(link);
  
          link.click();
          document.body.removeChild(link);
        })
        dispatch({
          type: LOADED_EXPORT_REPORT,
          data: response?.data,
        });
      })
      .catch((error) => {
        console.log("Export in catch error",error);
        dispatch({
          type: LOADED_EXPORT_REPORT,
        });
        message.error('Error while exporting data.');

        if (
                error?.response?.status === 401 ||
                error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_COMMERCIAL_SIGNUP_REPORT_CSV_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
}

// Get the scorpion channel catalog
export const getChannelsCatalog = () => {
  return (dispatch) => {
    return axiosInstance
      .get(`channel-attribution/`)
      .then((response) => {
        dispatch({
          type: GET_CHANNELS_SUCCESSFULLY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
                error?.response?.status === 401 ||
                error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_CHANNELS_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
}

export const getCouponCodeReport = (data) => {
  let field_office__uuid__in, 
    created_at__lte,
    created_at__gte,
    coupon_type
  ;
  
  if (data?.field_office_uuids?.length > 1) {
    const franchises = data?.field_office_uuids?.join(',');
    field_office__uuid__in = franchises;
  }

  if (data?.field_office_uuids?.length === 1)
  {
    field_office__uuid__in = data?.field_office_uuids?.join(',');
  }

  if(data?.start_date && data?.end_date)
  {
    created_at__lte = moment(data.end_date).format('YYYY-MM-DDT23:59:59');
    created_at__gte = moment(data.start_date).format('YYYY-MM-DDT00:00:00');
  }

  if(data?.couponType)
  {
    if(!data?.couponType.includes('all'))
      coupon_type = data?.couponType.join(',');
    else
      coupon_type = 'perc_off_init_clean,dollar_off_services,perc_off_services,free_gift';
  }

  const params = {
    coupon_type,
    created_at__lte,
    created_at__gte,
    limit: data.limit,
    field_office__uuid__in,
    offset: data.offset,
    ordering: data.ordering,
  }

  return (dispatch) => {
    return axiosInstance
      .get(`crm/customer-coupon-report`, {params})
      .then((response) => {
        dispatch({
          type: GET_COUPON_CODE_REPORT_SUCCESSFULLY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
                error?.response?.status === 401 ||
                error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_COUPON_CODE_REPORT_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
}

export const getCouponCodeReportCSV = (data) => {
  let field_office__uuid, 
    created_at__lte,
    created_at__gte,
    coupon_type
  ;
  
  if (data?.field_office_uuids?.length > 1) {
    const franchises = data?.field_office_uuids?.join(',');
    field_office__uuid = franchises;
  }

  if (data?.field_office_uuids?.length === 1)
  {
    field_office__uuid = data?.field_office_uuids?.join(',');
  }

  if(data?.start_date && data?.end_date)
  {
    created_at__lte = moment(data.start_date).format('YYYY-MM-DDT23:59:59');
    created_at__gte = moment(data.end_date).format('YYYY-MM-DDT00:00:00');
  }

  if(data?.couponType)
  {
    if(!data?.couponType.includes('all'))
      coupon_type = data?.couponType.join(',');
    else
      coupon_type = 'perc_off_init_clean, dollar_off_services, perc_off_service, free_gift';
  }

  const params = {
    coupon_type,
    created_at__lte,
    created_at__gte,
    limit: data.limit,
    field_office__uuid,
    offset: data.offset,
    ordering: data.ordering,
  };

  return (dispatch) => {
    return axiosInstance
      .get(`crm/customer-coupon-report`, {params}, {timeout: 50000})
      .then((response) => {
        let data = response.data;
        var blob = new Blob([data], { type: "text/csv"});
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "Residential Lead Report.csv";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        dispatch({
          type: LOADED_EXPORT_REPORT,
        });
      
      })
      .catch((error) => {
        console.log("Export in catch error",error);
        dispatch({
          type: LOADED_EXPORT_REPORT,
        });
        message.error('Error while exporting data.');

        if (
                error?.response?.status === 401 ||
                error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_COUPON_CODE_REPORT_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
}

export const getCancellationReportCSV = (data) => {
  const params = {
    ...data,
    "offset": 0,
    "limit": 100000
  }

  return (dispatch) => {
    return axiosInstance
      .get(`crm/customer-cancelation-report`, {params}, {timeout: 50000})
      .then((response) => {
        let headers = getCSVColumns('cancellation');
        let data = response.data.results;
        let rows = [headers.join(',')];

        data.forEach(item => {
          let row =
            `${item?.first_name ? convertFirstCharToUppercase(item?.first_name) + ' ' + convertFirstCharToUppercase(item?.last_name) : 'NA'},` +
            `${item?.field_office?.name ? item?.field_office.name : 'NA'},` +
            `${item?.created_at ? moment(item?.created_at).format("L") : 'NA'},` +
            `${item?.invoice_address?.address ?item?.invoice_address?.address :'NA'},` +
            `${item?.invoice_address?.city ?item?.invoice_address?.city :'NA'},` +
            `${item?.invoice_address?.state ?item?.invoice_address?.state:'NA'},` +
            `${item?.invoice_address?.zip_code ?item?.invoice_address?.zip_code :'NA'},` +
            `${item?.channel_attribution && item?.channel_attribution?.name !== 'Unknown' ? item?.channel_attribution?.name : 'NA'},` +
            `${item?.cancelation_reason ? `"${CANCELLATION_REASON[item?.cancelation_reason]}"` : 'NA'},` + 
            `${item?.cancelation_date ? moment(item?.cancelation_date).format("MM/DD/YYYY") : "NA"},` +
            `${item?.frequency?.length > 0 ? `"${item?.frequency.map(element => {return FREQUENCY_MAPPING[element]}).join(', ')}"` : 'NA'},` +
            `${item?.email?.includes('@doody.com') ? 'NA' : item?.email}`
          ;

          rows.push(row);
        });

        // To use
        let blob = new Blob([rows.join('\n')], { type: "application/CSV" });
        
        blob.text().then((csvContent) => {
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(new Blob([csvContent], { type: "application/CSV" }));
          
          let fileName = "Cancellation Report.csv";
          link.download = fileName;
          document.body.appendChild(link);
  
          link.click();
          document.body.removeChild(link);
        })
        dispatch({
          type: LOADED_EXPORT_REPORT,
        });
      
      })
      .catch((error) => {
        console.log("Export in catch error",error);
        dispatch({
          type: LOADED_EXPORT_REPORT,
        });
        message.error('Error while exporting data.');

        if (
                error?.response?.status === 401 ||
                error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_COMMERCIAL_SIGNUP_REPORT_CSV_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
}